module.exports = __webpack_public_path__ + "static/img/record.ac925a4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/record.gif
// module id = rV0l
// module chunks = 1